const ShortcutIcon = ({
  width = '24px',
  height = '24px',
  color = '#0A8276',
}: {
  width?: string;
  height?: string;
  color?: string;
}) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={width} height={height} viewBox="0 0 24 24" fill="none">
      <path
        d="M9.8533 14.6329L3.6523 10.6869C3.36859 10.5062 3.13502 10.2569 2.97321 9.96204C2.81139 9.66716 2.72656 9.33624 2.72656 8.99988C2.72656 8.66353 2.81139 8.3326 2.97321 8.03773C3.13502 7.74285 3.36859 7.49355 3.6523 7.31288L9.8523 3.36688C10.4942 2.95826 11.2394 2.74121 12.0003 2.74121C12.7612 2.74121 13.5064 2.95826 14.1483 3.36688L20.3483 7.31288C20.632 7.49355 20.8656 7.74285 21.0274 8.03773C21.1892 8.3326 21.274 8.66353 21.274 8.99988C21.274 9.33624 21.1892 9.66716 21.0274 9.96204C20.8656 10.2569 20.632 10.5062 20.3483 10.6869L14.1483 14.6329C13.5064 15.0415 12.7612 15.2586 12.0003 15.2586C11.2394 15.2586 10.4952 15.0415 9.8533 14.6329Z"
        stroke={color}
        strokeWidth="1.5"
      />
      <path
        d="M18.2863 12L20.3493 13.313C20.633 13.4937 20.8666 13.743 21.0284 14.0378C21.1902 14.3327 21.275 14.6636 21.275 15C21.275 15.3364 21.1902 15.6673 21.0284 15.9622C20.8666 16.257 20.633 16.5063 20.3493 16.687L14.1483 20.633C13.5064 21.0416 12.7612 21.2587 12.0003 21.2587C11.2394 21.2587 10.4942 21.0416 9.8523 20.633L3.6523 16.687C3.36859 16.5063 3.13502 16.257 2.97321 15.9622C2.81139 15.6673 2.72656 15.3364 2.72656 15C2.72656 14.6636 2.81139 14.3327 2.97321 14.0378C3.13502 13.743 3.36859 13.4937 3.6523 13.313L5.7143 12"
        stroke={color}
        strokeWidth="1.5"
      />
    </svg>
  );
};

export default ShortcutIcon;
